import { lazyGetRibbonModeMenuSections } from 'owa-mail-ribbon-sections/lib/sections';
import type { MailboxInfo } from 'owa-client-types';

import { setMenuDefinition } from '../../mutatorActions/setMenuDefinition';

export const onRibbonModeMenuClicked = (mailboxInfo: MailboxInfo): void => {
    lazyGetRibbonModeMenuSections.import().then(getRibbonMenuOptionsSections => {
        setMenuDefinition(
            'RibbonModeOptionsMenuDefinitionStore',
            undefined /* projectionTabId */,
            () => {
                return {
                    sections: getRibbonMenuOptionsSections(mailboxInfo),
                };
            }
        );
    });
};
